import classNames from "classnames";
import { ReactNode } from "react";
import { createUseStyles } from "react-jss";
import Button from "../Button";
import { useNavigate } from "react-router";

export interface CardProps {
  className?: string;
  icon?: string;
  header?: string;
  description?: string;
  blank?: boolean;
  children?: ReactNode;
  buttonLabel?: string;
  route?: string;
}

const useStyles = createUseStyles({
  root: {
    backgroundColor: "#fff",
    padding: "30px",
    flexBasis: "28%",
    borderRadius: "5px",
    "@media (max-width: 1480px)": {
      marginBottom: "30px",
    },
  },
  icon: {
    width: "60px",
  },
  blank: {
    padding: "30px",
    borderRadius: "5px",
    backgroundColor: "#fff",
    "& h2": {
      marginBottom: "30px",
    },
  },
  button: {
    display: "inline-block",
    marginTop: "30px !important",
  },
});

const Card = ({
  className,
  icon,
  header,
  description,
  blank = false,
  children,
  buttonLabel,
  route,
}: CardProps) => {
  const classes = useStyles();
  const navigate = useNavigate();
  return (
    <div
      className={classNames(className, {
        [classes.blank]: blank,
        [classes.root]: !blank,
      })}
    >
      {icon && <img className={classes.icon} alt="icon" src={icon} />}
      {header && <h3>{header}</h3>}
      {description && <p>{description}</p>}
      {children}
      {buttonLabel && route && (
        <Button
          className={classes.button}
          label={buttonLabel}
          onClick={() => navigate(route)}
        />
      )}
    </div>
  );
};

export default Card;
